import { call, put, takeLatest } from 'redux-saga/effects';
import { Users } from 'services/api';
import {
  adminUsers,
  adminUsersSuccess,
  adminUsersFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* getAdminUsers() {
  try {
    const { data } = yield call(Users.adminUser);
    yield put(adminUsersSuccess(data));
  } catch (e) {
    yield put(adminUsersFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(adminUsers, getAdminUsers);
